type GuestContainerRestrictionReason = "missingHomeSite" | "missingLocations";

interface GuestContainerRestriction {
  isRestricted: boolean;
  reason: GuestContainerRestrictionReason | null;
  message: string | null;
}

export const getGuestContainerRestrictionStatus = (
  isGuestUser: boolean,
  userHomeSite?: string | null,
  availableLocations?: unknown[] | null,
): GuestContainerRestriction => {
  if (!isGuestUser) {
    return { isRestricted: false, reason: null, message: null };
  }

  if (userHomeSite == null || userHomeSite === "") {
    return {
      isRestricted: true,
      reason: "missingHomeSite",
      message:
        "Home site assignment is required to manage containers. Please contact your ExxonMobil representative.",
    };
  }

  if (!availableLocations || availableLocations.length === 0) {
    return {
      isRestricted: true,
      reason: "missingLocations",
      message:
        "At least one location assignment is required to manage containers. Please contact your ExxonMobil representative.",
    };
  }

  return { isRestricted: false, reason: null, message: null };
};
